var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductSmallRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.200009 1.69961C0.0555797 1.50704 -0.0145392 1.26883 0.00252486 1.02872C0.019589 0.788612 0.12269 0.562716 0.292902 0.392504C0.463113 0.222293 0.68901 0.119191 0.929119 0.102127C1.16923 0.0850625 1.40744 0.155182 1.60001 0.299611L5.60001 4.29961C5.78323 4.48654 5.88586 4.73786 5.88586 4.99961C5.88586 5.26136 5.78323 5.51268 5.60001 5.69961L1.60001 9.69961C1.40744 9.84404 1.16923 9.91416 0.929119 9.8971C0.68901 9.88003 0.463113 9.77693 0.292902 9.60672C0.12269 9.43651 0.0195891 9.21061 0.00252496 8.9705C-0.0145391 8.73039 0.0555798 8.49219 0.200009 8.29961L3.48001 4.99961L0.180008 1.69961L0.200009 1.69961Z",
    fill: "#5D6FF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSmallRightArrow);
export default __webpack_public_path__ + "static/media/product-small-right-arrow.06d27379350bfd3e7dbee6407dcafa2b.svg";
export { ForwardRef as ReactComponent };